export enum FeaturedSectionType {
  BANNER = 'BANNER',
  CUSTOM = 'CUSTOM',
  GENRE = 'GENRE',
  POPULAR = 'POPULAR',
  WATCHING = 'WATCHING',
  NEWEST = 'NEWEST',
  CUSTOM_MEDIUM = 'CUSTOM_MEDIUM',
  ORIGINALS = 'ORIGINALS',
  WATCHLIST = 'WATCHLIST',
}
